import RequestClass from '@api/request/RequestClass';
import {API_NAMESPACE} from '@constants/general';
import {METHOD_DELETE, METHOD_POST} from '@constants/http';
import type {EmptyRestApiResponse} from '@interfaces/RestApiResponse';
import type {FreeSubscription} from '@interfaces/Subscription';

export async function cancelSubscription(
    code: string,
    token: string,
    items: FreeSubscription,
): Promise<EmptyRestApiResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/subscription/cancel/${code}`, METHOD_DELETE)
        .setAuthHeader(token)
        .setParams(items)
        .send()) as Promise<EmptyRestApiResponse>;
}

export async function createSubscription(
    code: string,
    items: FreeSubscription,
): Promise<EmptyRestApiResponse> {
    return (await new RequestClass(`${API_NAMESPACE}/subscription/${code}`, METHOD_POST)
        .setParams(items)
        .send()) as Promise<EmptyRestApiResponse>;
}
